import { Dispatch, SetStateAction, useState, useEffect, useCallback } from 'react';
import s from './index.module.scss';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';
import { generateSignature } from '@/util/signature';
import { Stage, COUNTDOWN } from '../const';
import { useToast } from '@/stores/ToastContext';
import { postApi } from '@/util/request';
import { useRouter } from 'next/router';
import CountDown from '../../../../commonComponents/countDown';
import VerificationInput from './verificationInput';
import useScreenWidthBelowThreshold from '../../../../hooks/useScreenWidthBelowThreshold';
import HCaptcha from '@/component/hCaptcha/h5Index';
import { OpenCAPTCHA } from '@/component/login/logEntries/const';
import { setToken } from '@/util/tokenManager';

export default function Phone(props: {
  setStage: Dispatch<SetStateAction<number>>;
  countryCode: string;
  mobileNumber: string;
  countdown: number;
  setCountdown: Dispatch<SetStateAction<number>>;
}) {
  const { t } = useTranslation();
  const router = useRouter();
  const isScreenWidthBelow700px = useScreenWidthBelowThreshold(1281);
  const { setStage, countryCode, mobileNumber, countdown: countDown, setCountdown: setCountDown } = props;
  const countryCodeNumber = Number(countryCode);

  const [confirmActive, setConfirmActive] = useState(false);
  const [code, setCode] = useState<number>();
  const showToast = useToast();
  const [showCaptcha, setShowCaptcha] = useState(false);

  const onVerify = async () => {
    if (!(String(code)?.length === 6)) {
      return;
    }
    const res = await postApi(`${window.location.protocol}//${window.location.host}/web/account/login`, {
      grantType: 'phone', // 类型可能为：phone，email
      countryCode: countryCodeNumber,
      mobileNumber,
      code,
    });
    // 已有账号
    if (res.meta?.code === 200) {
      if (res.data?.token) {
        setToken(res.data.token);
        router.push('/playground_mobile');
      }
    } else if (res.meta?.code === 40014) {
      showToast('Please make sure you entered the right verification code');
    } else {
      showToast('Please confirm your phone number is correct.');
    }
  };

  const onComplete = useCallback((inputs) => {
    setCode(Number(inputs?.join('')));
  }, []);

  useEffect(() => {
    setConfirmActive(String(code)?.length === 6);
  }, [code]);

  const handleShowCaptcha = () => {
    if (OpenCAPTCHA) {
      if (countDown) return;
      setShowCaptcha(true);
    } else {
      handleSendAgain();
    }
  };

  const handleSendAgain = useCallback(async () => {
    setShowCaptcha(false);
    if (countDown) return;
    // return router.push('/log-entries/verify-phone');
    const res = await fetch(`${window.location.protocol}//${window.location.host}/api/confirmation-code`, {
      method: 'POST',
      body: JSON.stringify({
        mobileNumber,
        grantType: 'phone',
        countryCode: countryCodeNumber,
        signature: generateSignature('phone', '', `${countryCodeNumber}`, mobileNumber),
        blackbox: window.__blackbox,
      }),
    });
    if (res.ok) {
      // 检查响应是否成功
      setCountDown(COUNTDOWN);
    } else {
      showToast(t('DUET_H5_ACCOUNT_MANAGE_REQUEST_MAX_ERROR_TOAST'));
    }
  }, [countDown, countryCodeNumber, mobileNumber]);

  const onCodeChange = (value) => {
    if (value?.join('').length === 4) {
      setConfirmActive(true);
    } else {
      setConfirmActive(false);
    }
  };

  return (
    <>
      <div className={s.icon} />
      <div className={s.title}>{t('DUET_WEB_SIGNIN_OTP_TITLE')}</div>
      <div className={s.sendAgainWrapper}>
        <div className={s.number}>
          +{countryCodeNumber} {mobileNumber}
        </div>
        <div className={cx(s.sendAgain, { [s.countDown]: countDown })} onClick={handleShowCaptcha}>
          {countDown > 0 ? countDown : t('DUET_WEB_SIGNIN_OTP_RESEND')}
        </div>
      </div>
      <VerificationInput
        onComplete={onComplete}
        // className={invalidCode ? s.invalid : null}
        onChange={onCodeChange}
      />
      <div className={s.changeNumber} onClick={() => setStage(Stage.Phone)}>
        {t('DUET_WEB_SIGNIN_OTP_CHANGENUMBER')}
      </div>
      <div className={cx(s.button, { [s.active]: confirmActive })} onClick={onVerify}>
        {t('DUET_H5_ACCOUNT_MANAGE_PHONE_LOGIN_NUMBER_PAGE_NEXT_BUTTON')}
      </div>
      {showCaptcha && <HCaptcha setShowCaptcha={setShowCaptcha} toNext={handleSendAgain} />}
    </>
  );
}
